<template>
  <div class="chat">
    <Launcher
      :onMessageWasSent="onMessageWasSent"
      :isOpen="isChatOpen"
      :isMessageSent="isMessageSent"
      :close="closeChat"
      :open="openChat"
      :title="$t('feedback.header')"
    />
  </div>
</template>

<script>
import Launcher from "@/components/chat/Launcher.vue";

import { orgConfig, orgConfiguration } from "@/mixins";

export default {
  mixins: [orgConfig],
  components: {
    Launcher
  },
  data() {
    return {
      isChatOpen: false,
      isMessageSent: false
    };
  },
  computed: {
    apiEndpoint() {
      return process.env.VUE_APP_API_STAGE !== "production"
        ? "https://stage-portal.apitalks.com"
        : "https://api.apitalks.com";
    }
  },
  methods: {
    onMessageWasSent(message) {
      const baseUrl = this.apiEndpoint;
      const id = orgConfiguration(this.organizationConfig, "organization.id");
      const url = `${baseUrl}/organizations/${id}/feedbacks`;

      this.axios
        .post(url, { ...message, url: window.location.toString() })
        .then(() => {
          this.isMessageSent = true;
        })
        .catch(() => {
          this.isMessageSent = false;
        });
    },
    openChat() {
      this.isMessageSent = false;
      this.isChatOpen = true;
    },
    closeChat() {
      this.isChatOpen = false;
    }
  }
};
</script>

<style lang="css" scoped>
.chat {
  z-index: 1000
}
</style>
